import { useMediaQuery } from '@rhg/libs/material';

/**
 * NOTE: Use the `useTheme` hook to get the current theme's color mode
 *
 * Hook to get the user's preferred color scheme from the browser.
 */
function usePrefersDarkMode() {
    return useMediaQuery('(prefers-color-scheme: dark)');
}

export default usePrefersDarkMode;
